import React from 'react';
import styles from './ProfileFormContainer.module.css';

const ProfileFormContainer = ({ currentStep, setCurrentStep, children, steps, userInfo }) => {
  const handleNext = () => {
    if (currentStep < steps.length - 1) setCurrentStep(currentStep + 1);
  };

  const handlePrev = () => {
    if (currentStep > 0) setCurrentStep(currentStep - 1);
  };

  return (
    <div className={styles.container}>
      <div className={styles.sidebar}>
        <div className={styles.userInfo}>
          {userInfo.profileImage ? (
            <img src={userInfo.profileImage} className={styles.userAvatar} alt="User Avatar"/>
          ) : (
            <span className={styles.userAvatar}>A</span>
          )}
          <div className={styles.userDetails}>
            <span className={styles.preferredName}>
              {userInfo.preferredFirstName || 'Your Name'}
            </span>
            <span className={styles.legalName}>
              {userInfo.legalFirstName} {userInfo.legalLastName}
            </span>
          </div>
        </div>
        <nav className={styles.nav}>
          {steps.map((step, idx) => (
            <button
              key={idx}
              className={`${styles.navItem} ${idx === currentStep ? styles.active : ''}`}
              onClick={() => setCurrentStep(idx)}
            >
              {step}
            </button>
          ))}
        </nav>
      </div>

      <div className={styles.formContent}>
        <div className={styles.formArea}>
          {children}
        </div>

        <div className={styles.navigation}>
          {currentStep < steps.length - 1 && <button className={styles.nextButton} onClick={handleNext}>Next</button>}
          {currentStep === steps.length - 1 && <button className={styles.nextButton}>Submit</button>}
        </div>
      </div>
    </div>
  );
};

export default ProfileFormContainer;
